// @flow

import Swiper from "swiper/dist/js/swiper.min.js";
import "swiper/dist/css/swiper.min.css";
import "./feature-blocks.scss";

export function initFeaturedBlocks() {

    var featuredBlockSlider = void 0;
    var breakpoint = window.matchMedia('(min-width: 992px)');

    var init = function () {
        if (document.querySelector(".featured-blocks") == undefined) return;

        breakpoint.addListener(bpChecker);
        bpChecker();
    };

    var bpChecker = function () {
        if (breakpoint.matches) {
            if(featuredBlockSlider !== undefined) featuredBlockSlider.destroy(true, true);
            return;
        }
        else {
            return initSlider();
        }
    };

    var initSlider = function() {

        featuredBlockSlider = new Swiper ('.featured-blocks-slider', {
            slidesPerView: 'auto',
            loop: false,
            threshold: 20,
            spaceBetween: 20,
            autoplay: {
                delay: 8000,
            },
            breakpoints: {
                1000: {
                    slidesPerView: 2.4,
                },
                768: {
                    slidesPerView: 1.2,
                }
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        });
    }

    init();
}
